import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { useTranslation } from 'react-i18next';

export default function SmallHelpButton() {
	const [isModalVisible, setIsModalVisible] = useState(false);
	const { t } = useTranslation();

	const showModal = () => {
		setIsModalVisible(true);
	};

	const handleOk = () => {
		setIsModalVisible(false);
	};

	const handleCancel = () => {
		setIsModalVisible(false);
	};

	return (
		<>
			<Button onClick={showModal} className="ant-btn small-help-button">
				{t('helpButtonLabel')}
			</Button>
			<Modal
				title={t('helpButtonLabel')}
				visible={isModalVisible}
				onOk={handleOk}
				onCancel={handleCancel}
				footer={null}
				className="help-modal"
				width={1000}
				centered
				style={{ top: 0 }}
			>
				<div className="modal-content">
					<p>{t('graphExplanation')}</p>
				</div>
			</Modal>
		</>
	);
}